import { render, staticRenderFns } from "./trans-page.vue?vue&type=template&id=39708b13&scoped=true&"
import script from "./trans-page.vue?vue&type=script&lang=js&"
export * from "./trans-page.vue?vue&type=script&lang=js&"
import style0 from "./trans-page.vue?vue&type=style&index=0&id=39708b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39708b13",
  null
  
)

export default component.exports